export const getApiErrorMessage = (error: unknown, fallback: string) => {
  if (typeof error === 'object' && error !== null && 'response' in error) {
    const responseData = (
      error as { response?: { data?: { error?: unknown; message?: unknown } } }
    ).response?.data
    const responseError = responseData?.error
    if (typeof responseError === 'string') return responseError

    const responseMessage = responseData?.message
    if (typeof responseMessage === 'string') return responseMessage
  }

  if (error instanceof Error && error.message) return error.message

  return fallback
}

export const formatDisplayValue = (value?: string | number | null) =>
  value === undefined || value === null || value === '' ? '—' : value

export const formatPhoneNumber = (value: string): string => {
  const numericValue = value.replace(/\D/g, '')

  if (!numericValue) return ''

  if (numericValue.length <= 3) {
    return `(${numericValue}`
  } else if (numericValue.length <= 6) {
    return `(${numericValue.slice(0, 3)}) ${numericValue.slice(3)}`
  } else {
    return `(${numericValue.slice(0, 3)}) ${numericValue.slice(
      3,
      6
    )}-${numericValue.slice(6, 10)}`
  }
}

export const validatePhoneNumber = (value: string): boolean => {
  return /^\(\d{3}\) \d{3}-\d{4}$/.test(value)
}

export const formatZipCode = (value: string): string => {
  const numeric = value.replace(/[^\d]/g, '').slice(0, 9)

  if (numeric.length <= 5) {
    return numeric
  }

  return `${numeric.slice(0, 5)}-${numeric.slice(5)}`
}

export const formatTaxId = (taxId: string): string => {
  const digits = taxId.replace(/\D/g, '')

  if (digits.length <= 2) return digits

  return `${digits.slice(0, 2)}-${digits.slice(2, 9)}`
}

export const formatAveragePurchase = (value: string): string => {
  const digits = value.replace(/\D/g, '')

  const limitedDigits = digits.slice(0, 8)

  return `$${limitedDigits.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
}

export const validateZipCode = (value: string): boolean => {
  return /^\d{5}(-\d{4})?$/.test(value)
}

export const validateTaxId = (taxId: string): boolean => {
  const taxIdPattern = /^\d{2}-\d{7}$/
  return taxIdPattern.test(taxId)
}

export const validateExpectedMonthlySales = (value: string): boolean => {
  const digits = value.replace(/\D/g, '')
  const pattern = /^\d{1,8}$/
  return pattern.test(digits)
}
export const isLocalhost = (): boolean => {
  return window.location.hostname === 'localhost'
}

const COOKIE_DOMAIN = process.env.REACT_APP_COOKIE_DOMAIN
export const cookieOptions = {
  path: '/',
  domain: isLocalhost() ? undefined : COOKIE_DOMAIN,
  secure: !isLocalhost(),
  sameSite: isLocalhost() ? ('Lax' as const) : ('None' as const)
}
